import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { COMPANY } from "../lib/data";
import { trackEvent } from "../lib/api";

export default function FloatingCTA() {
  return (
    <div data-testid="floating-cta" className="fixed bottom-0 inset-x-0 z-40 md:hidden">
      <div className="grid grid-cols-2 gap-px bg-neutral-200 border-t border-neutral-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
        <a
          href={`tel:${COMPANY.phoneRaw}`}
          data-testid="floating-call-button"
          onClick={() => trackEvent("call", "Barre mobile - Appeler")}
          className="flex items-center justify-center gap-2 py-3.5 bg-vegetal-600 text-white font-medium text-sm"
        >
          <Phone className="h-4 w-4" /> Appeler
        </a>
        <Link
          to="/devis"
          data-testid="floating-devis-button"
          onClick={() => trackEvent("cta", "Barre mobile - Devis")}
          className="flex items-center justify-center gap-2 py-3.5 bg-terracotta-500 text-white font-medium text-sm"
        >
          <FileText className="h-4 w-4" /> Devis gratuit
        </Link>
      </div>
    </div>
  );
}
